import Redfox from '@ali/ncom-speedy3-redfox';
import {parseQueryString}  from './utils';
const mtop =  ( { api, data, onSuccess, onError } ) => {
 
    if (!api) reject('api不能为空');
    // const queryParams = parseQueryString() || {};
    // mtop预发 通过绑定 acs.h.alibaba.com  pre-acs.h.alibaba.com
    Redfox.$fetch({
      apiConfig: {
        api: {
          web: {
            apiName: api,
            type: 'mtop',
            options: {
              headers: {},
            },
          },
        },
        v: '1.0',
        data: { env: 'freepage_pc', endpoint:"pc", ...data },
      },
      // env: queryParams.env === 'pre' ? 'pre': '',
      disableCache: true,
      onError: (result) => {
        onError &&  onError(result.data);
      },
      // 成功之后的回调
      onSuccess: (result) => {
        if (result.data) {
          onSuccess && onSuccess(result.data);
        } else {
          onError && onError(result.data);
        }
      },
    });
  
};


const jsonp = ( { api, data, onSuccess, onError } ) => {
  Redfox.$fetch({
    apiConfig: {
      api: {
        web: {
          "apiName": api,
          "type": "jsonp",
          // 需要覆盖的options。如果用默认的fetch方法，那么可以在这里透传fetch参数
         
        },
      },
      data: { ...data, endpoint: 'pc'},
    },
    onError: (result) => {
      onError && onError(result.data);
    },
    // 成功之后的回调
    onSuccess: (result) => {
      if (result.data) {
        onSuccess && onSuccess(result.data);
      } else {
        onError && onError(result.data);
      }
    },
  });
}

export {
  jsonp,
  mtop,
}